import React from "react";

/**
 * Aktivity klienta / případu ve třech skupinách:
 * po termínu (nahoře, ať nezapadnou) → naplánované od nejbližší po
 * nejvzdálenější → hotové od nejnovější. Uvnitř skupiny je vždy první
 * ta nejblíž dnešku.
 */
const cas = (a) => new Date(a.date_start).getTime() || 0;

export function skupinyAktivit(items = []) {
  const po = [], plan = [], hotove = [];
  for (const a of items) {
    if (a.stav === "HOTOVA") hotove.push(a);
    else if (a.po_terminu) po.push(a);
    else plan.push(a);
  }
  po.sort((a, b) => cas(b) - cas(a));
  plan.sort((a, b) => cas(a) - cas(b));
  hotove.sort((a, b) => cas(b) - cas(a));
  return [
    { klic: "po_terminu", titul: "Po termínu", items: po },
    { klic: "naplanovane", titul: "Naplánované", items: plan },
    { klic: "hotove", titul: "Hotové", items: hotove },
  ].filter((g) => g.items.length);
}

/** Vykreslí skupiny s nadpisem a počtem; `render(a)` je řádek aktivity. */
export function SkupinyAktivit({ items, render, kompakt = false }) {
  return skupinyAktivit(items).map((g) => (
    <React.Fragment key={g.klic}>
      <div data-testid={`aktivity-skupina-${g.klic}`}
        className={`label-up flex items-center gap-2 ${kompakt ? "px-1 pt-2 pb-0.5" : "px-4 md:px-5 py-2 bg-[#fbfaf8] border-b border-line-soft"} ${
          g.klic === "po_terminu" ? "text-danger" : "text-muted"}`}>
        {g.klic === "po_terminu" && <span className="h-1.5 w-1.5 rounded-full bg-danger" />}
        {g.titul} · {g.items.length}
      </div>
      {g.items.map(render)}
    </React.Fragment>
  ));
}
